export enum QrCodeScanState {
    Done,
    Error,
    Waiting,
    Scaning
}
